<template>
  <v-card :loading="loading">
    <v-card-title>On-Site Contact Information</v-card-title>
    <v-card-text>
      <ValidationObserver ref="obs" v-slot="{ invalid, validated, passes, validate }">
        <v-form>
          <ValidationProvider name="name" rules="required"  v-slot="{ errors, valid }">
            <v-text-field
              label="Name"
              v-model="assignment_data.contact_name"
              :error-messages="errors"
              :success="valid"></v-text-field>
          </ValidationProvider>
          <ValidationProvider name="work_phone" rules="required"  v-slot="{ errors, valid }">
            <v-text-field
              label="Work Phone"
              v-model="assignment_data.contact_work_phone"
              :error-messages="errors"
              :success="valid"></v-text-field>
          </ValidationProvider>
          <ValidationProvider name="cell_phone" rules="required"  v-slot="{ errors, valid }">
            <v-text-field
              label="Cell Phone"
              v-model="assignment_data.contact_cell_phone"
              :error-messages="errors"
              :success="valid"></v-text-field>
          </ValidationProvider>
          <ValidationProvider name="email" rules="required|email"  v-slot="{ errors, valid }">
            <v-text-field
              label="Email"
              v-model="assignment_data.contact_email_address"
              :error-messages="errors"
              :success="valid"></v-text-field>
          </ValidationProvider>
          <v-btn color="primary" class="mr-4" @click="submit()" :disabled="invalid">submit</v-btn>
        </v-form>
      </ValidationObserver>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'

export default {
  props: {
    assignment_data: Object,
    loading: Boolean
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  methods: {
    submit() {
      this.$emit('updateinfo')
    }
  }
}
</script>